// useFeatureFlags — fetch the current user's resolved feature flags
// from the server. Returns a `{ <flag>: bool }` map, defaulting to an
// empty object (all-off) during the initial fetch so callers can gate
// UI safely.

import { useEffect, useState } from "react";
import api from "@/lib/api";

const LS_KEY = "calofay_feature_flags_v1";

const BUNDLED = {
  ai_coach: true,
  photo_food_log: true,
  barcode_scan: true,
  share_progress: true,
  streak_display: true,
  healthkit_sync: true,
  redeem_code_button: true,
  referral_program: false,
  weekly_recap_email: false,
  streak_freeze: false,
  reengagement_push: false,
};

let cached = null;

export function useFeatureFlags() {
  const [flags, setFlags] = useState(() => {
    if (cached) return cached;
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (raw) return JSON.parse(raw);
    } catch (_) {}
    return BUNDLED;
  });

  useEffect(() => {
    let alive = true;
    api.get("/feature-flags")
      .then((r) => {
        if (!alive) return;
        const data = r?.data;
        if (data && typeof data === "object") {
          setFlags(data);
          cached = data;
          try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (_) {}
        }
      })
      .catch(() => { /* keep bundled */ });
    return () => { alive = false; };
  }, []);

  return flags;
}

export function useFeatureFlag(key) {
  const flags = useFeatureFlags();
  return Boolean(flags?.[key]);
}
